module.exports = __webpack_public_path__ + "static/media/Footer Logo 4.75e48230.png";